import { Injectable, Inject } from '@angular/core';
import { AutoTablePageableResponse } from '@muchencute/mrrs-types';
import { Observable, BehaviorSubject } from 'rxjs';
import { Region } from './region-models';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../auth/auth.service';
import * as _ from 'lodash';
import { CORE_CONFIG } from '../environment';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RegionService {

  regions = new BehaviorSubject<Region[]>([]);

  private _baseURL: string;

  constructor(private httpClient: HttpClient,
              @Inject(CORE_CONFIG) private coreConfig: any) {
    this._baseURL = `${this.coreConfig.endpoint}api/v1/region`;
    this.getRegionList({ pageSize: 1000 }).subscribe();
  }

  getRegionList(params: { [param: string]: any }): Observable<AutoTablePageableResponse<Region>> {
    return this.httpClient.get<AutoTablePageableResponse<Region>>(`${this._baseURL}s`, {
      params
    }).pipe(
      tap(result => this.regions.next(result.pageItems)),
      tap(rs => rs.pageItems.filter(it => it.regionname !== 'Global'))
    );
  }

  getRegionsTemporary(params: { [param: string]: any }): Observable<AutoTablePageableResponse<Region>> {
    return this.httpClient.get<AutoTablePageableResponse<Region>>(`${this._baseURL}s`, {
      params
    });
  }

  newRegion(region: Region): Observable<any> {
    return this.httpClient.post(`${this._baseURL}`, region);
  }

  updateRegion(region: Region): Observable<any> {
    return this.httpClient.put(`${this._baseURL}/${region.regionname}`, region);
  }

  removeRegions(regionName: string | string[]): Observable<any> {
    if (!_.isArray(regionName)) {
      return this.httpClient.delete(`${this._baseURL}/${regionName}`);
    } else {
      return this.httpClient.delete(`${this._baseURL}`, {
        params: {
          regionName
        }
      });
    }
  }

}
